import BaseModel from './BaseModel';
import Cost from './Cost';
import Resource from './Resource';
import Unit from './Unit';
import * as AT from '../../components/container/attributes';

export default class CostItem extends BaseModel {
  constructor({
    id,
    number,
    designation,
    active = true,
    cost = undefined,
    resource = undefined,
    unit = undefined,
    quantity = undefined,
    quantityExpression = undefined,
    price = undefined,
    amount = undefined,
    comment = undefined,
    pricePrecision = undefined,
  }) {
    super(id, number, designation);
    this.active = active;
    this.cost = cost ? new Cost(cost) : null;
    this.resource = resource ? new Resource(resource) : null;
    this.unit = unit ? new Unit(unit) : null;
    this.quantity = quantity;
    this.quantityExpression = quantityExpression;
    this.price = price;
    this.amount = amount;
    this.comment = comment;
    this.pricePrecision = pricePrecision;
  }

  static get fkName() {
    return undefined;
  }
  static get apiRoute() {
    return 'cost_data';
  }
  static get detailPageRoute() {
    return 'costsView';
  }
  static get listPageRoute() {
    return 'costsView';
  }
  get fkName() {
    return CostItem.fkName;
  }
  get apiRoute() {
    return CostItem.apiRoute;
  }
  get listPageRoute() {
    return CostItem.listPageRoute;
  }
  get detailPageRoute() {
    return CostItem.detailPageRoute;
  }

  static get joinAttrsKey() {
    return [
      'number',
      'designation',
      'cost',
      'quantity',
      'comment',
      'price',
      'amount',
      'resource',
    ];
  }
  static get listDisplayAttrs() {
    return this.getAttributes(
      [
        'number',
        'designation',
        'unit',
        'quantity',
        'price',
        'amount',
        'comment',
      ],
      ['resource', 'sortOrder', 'pricePrecision'],
    );
  }

  static get allAttributes() {
    return [
      this.NUMBER_ATTRIBUTE({}, {maxWidth: '1fr'}),
      this.DESIGNATION_ATTRIBUTE({}, {maxWidth: '2fr'}),
      this.ACTIVE_ATTRIBUTE(),
      new AT.FkCostAttribute({
        name: 'cost',
        joinPath: ['cost!fk_cost_data_cost_id_cost'],
        tableProperties: {
          header: 'hit-base.common.cost',
        },
      }),
      new AT.FkResourceAttribute({
        name: 'resource',
        joinPath: ['resource!fk_cost_data_resource_id_resource'],
        tableProperties: {
          header: 'hit-base.common.resource',
        },
      }),
      new AT.FkUnitAttribute({
        name: 'unit',
        joinPath: ['unit!fk_cost_data_unit_id_unit'],
        tableProperties: {
          header: 'hit-base.common.unit',
          maxWidth: '0.5fr',
        },
      }),
      new AT.NumberAttribute({
        name: 'quantity',
        decimalPrecision: 3,
        creationValue: 0,
        tableProperties: {
          header: 'hit-app.common.quantity',
        },
      }),
      new AT.StringAttribute({
        name: 'quantityExpression',
        column: 'quantity_expression',
        tableProperties: {
          header: 'hit-app.transaction.expression',
        },
      }),
      new AT.DecimalAttribute({
        name: 'price',
        decimalPrecisionForcedByColumn: 'pricePrecision',
        creationValue: 0.0,
        tableProperties: {
          header: 'hit-app.common.price',
        },
      }),
      new AT.DecimalAttribute({
        name: 'amount',
        decimalPrecision: 2,
        creationValue: 0.0,
        readOnly: true,
        tableProperties: {
          readOnly: true,
          header: 'hit-app.common.amount',
        },
      }),
      new AT.StringAttribute({
        name: 'comment',
        tableProperties: {
          header: 'hit-base.common.comment',
          maxWidth: '1fr',
        },
      }),
      new AT.IntegerAttribute({
        name: 'sortOrder',
        column: 'sort_order',
        readOnly: true,
      }),
      new AT.IntegerAttribute({
        name: 'pricePrecision',
        column: 'price_precision',
      }),
    ];
  }
}
